import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

// Sifarnik za padajuce menije u kartonu klijenta.
// Kategorije: diagnosis, allergy, intolerance, medicine, food
class TagService {
  getTags() {
    return axios.get(apiUrl + 'tags', { headers: authHeader() });
  }

  getTagsByCategory(category) {
    return axios.get(apiUrl + 'tags/category/' + category, { headers: authHeader() });
  }

  addTag(category, name) {
    return axios.post(apiUrl + 'tags', { category, name }, { headers: authHeader() });
  }

  deleteTag(id) {
    return axios.delete(apiUrl + 'tags/' + id, { headers: authHeader() });
  }

  updateTag(id, name) {
    return axios.put(apiUrl + 'tags/' + id, { name }, { headers: authHeader() });
  }
}

export default new TagService();
